// extracted by mini-css-extract-plugin
module.exports = {"global-toast-view":"Toast_global-toast-view__s2NXY"};